<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div v-if="data">
      <div class="topTabRect">
        <van-tabs v-model="activeTab" class="tabList" type="card" :color="GetDiveMainBack()" background="#eee" style="margin:none;" @change="onTabChange">
          <van-tab v-for="(item,index) in data.courseList" :key="index" :name="index===0?'':item.index" :title="item.name" />
          <van-tab title="更多课程" name="more" />
        </van-tabs>
      </div>
      <template v-for="(unitGroup,index) in data.unitGroupList">
        <div v-if="!unitGroup.isFinishExam" :key="index" class="UnitRect">
          <div :class="unitGroup.isActivity?'UnitTitle':'UnitTitle UnitRectDisable'" :style="'color:'+GetDiveMainBack()">
            {{ unitGroup.unitGroupName }}
          </div>
          <van-row v-for="unit in unitGroup.units" :key="unit.eCourseUnitId" class="lineRect">
            <template v-if="unit.type==='Video'">
              <div @click="onVideoPage(unit)">
                <van-col span="16">
                  <div :class="unitGroup.isActivity && unit.isActivity?'title':'title UnitRectDisable'">{{ unit.title }} </div>
                  <div :class="unitGroup.isActivity && unit.isActivity?'about':'about UnitRectDisable'">时长{{ ShowFloat(unit.videoLenSecond/60) }} min</div>
                </van-col>
                <van-col v-if="unitGroup.isActivity && unit.isActivity" span="8">
                  <div v-if="unit.isPass" class="tag" :style="'background-color:'+GetDiveMainBack()">
                    <span>完成</span>
                  </div>
                  <div v-if="!unit.isPass" class="tag" :style="'color:'+GetDiveMainBack()+';border-color:'+GetDiveMainBack()">
                    <span v-if="unit.videoLenSecond<=0">0%</span>
                    <span v-if="unit.videoLenSecond>0">{{ (unit.videoReadSecond*100 / unit.videoLenSecond).toFixed(0) }}%</span>
                  </div>
                </van-col>
              </div>
            </template>
            <template v-if="unit.type==='Subscribe'">
              <van-col span="16">
                <div :class="unitGroup.isActivity && unit.isActivity?'title':'title UnitRectDisable'">{{ unit.title }} </div>
                <div v-if="unit.bookTime" class="about">预约日期:{{ formatDate(unit.bookTime,"yyyy-MM-dd hh:mm",true) }}</div>
                <div v-if="unit.bookTime && unit.isSimple" class="about">我们将会在<b>课程开始前通知您参加</b>,若当期无法参加则下一期继续通知您参加.</div>
                <div v-if="!unit.bookTime && unit.isSimple" class="about">预约在线课程、考试，完成理论课程的学习,预约后，我们将会在<b>课程开始前通知您参加</b>若当期无法参加则下一期继续通知您参加.</div>

              </van-col>
              <van-col v-if="unit.isActivity" span="8" class="rigth examButtonRect">
                <van-button v-if="!unit.subscribeType || unit.subscribeType==='NONE'" type="primary" round size="mini" style="width:90%;" :loading="buttonLoading" :color="GetDiveMainBack()" @click="onSubscribe(unit)">立即预约</van-button>
                <van-button v-if="unit.subscribeType==='BOOK'" type="primary" round size="mini" style="width:90%;" :color="GetColorSecondary()" :loading="buttonLoading" @click="onSubscribeCancel(unit)">取消预约</van-button>
                <van-button v-if="unit.subscribeType==='Finish'" type="primary" round size="mini" style="width:90%;" :color="GetDiveMainBack()">完成</van-button>
              </van-col>
            </template>
            <template v-if="unit.type==='Test'">
              <van-col span="16">
                <div :class="unitGroup.isActivity && unit.isActivity?'title':'title UnitRectDisable'">{{ unit.title }}<span v-if="unit.isPass" :style="'color:'+GetDiveMainBack()">PASS</span></div>
              </van-col>
              <van-col v-if="unit.examResultLastId" span="8">
                <div class="score rigth" :style="'color:'+GetDiveMainBack()">{{ unit.score }}分</div>
              </van-col>

              <van-col v-if="unit.isActivity && !unit.examResultLastId" span="24" class="rigth examButtonRect">
                <van-button type="primary" round size="mini" style="width:30%;" :color="GetDiveMainBack()" @click="onTest(unit)">开始测验</van-button>
              </van-col>
              <van-col v-if="unit.isActivity && unit.examResultLastId" span="12" class="rigth examButtonRect">
                <van-button type="primary" round size="mini" style="width:70%;margin-right:1em;" :color="GetDiveMainBack()" @click="onTest(unit)">再次测验</van-button>
              </van-col>
              <van-col v-if="unit.isActivity && unit.examResultLastId" span="12" class=" examButtonRect">
                <van-button type="primary" round size="mini" style="width:70%;margin-left:1em;" :color="GetDiveMainBack()" @click="onExamError(unit)">错题回顾</van-button>
              </van-col>
            </template>
          </van-row>
        </div>
        <div v-if="unitGroup.isFinishExam" :key="index" class="UnitRect">
          <div :class="unitGroup.isActivity?'UnitTitle':'UnitTitle UnitRectDisable'" :style="'color:'+GetDiveMainBack()">
            最终测验
            <van-tag v-if="unitGroup.isPassFinishExam" type="success">通过测验</van-tag>
            <van-tag v-if="!unitGroup.isPassFinishExam" type="danger">暂未通过</van-tag>
          </div>
          <van-row v-for="unit in unitGroup.units" :key="unit.eCourseUnitId" class="lineRect">
            <van-col span="16">
              <div :class="unitGroup.isActivity && unit.isActivity?'title':'title UnitRectDisable'">{{ unit.title }}<span v-if="unit.isPass" :style="'color:'+GetDiveMainBack()">PASS</span></div>
              <div class="about">{{ unit.totalNum }}题</div>
            </van-col>

            <van-col v-if="unit.isActivity && unit.examResultLastId" span="8" class="rigth examButtonRect">
              <div class="score rigth" :style="'color:'+GetDiveMainBack()">{{ unit.score }}分</div>
            </van-col>
            <van-col v-if="unit.isActivity && !unit.examResultLastId" span="8" class="rigth examButtonRect">
              <van-button type="primary" round size="mini" style="width:90%;" disabled :color="GetDiveMainBack()">开始测验</van-button>
            </van-col>
          </van-row>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Tab, Tabs, Tag, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, MyNotify, ShowFloat, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '在线课程',
      backurl: '/dive',
      id: undefined,
      ecourse: undefined,
      data: undefined,
      activeTab: 0,
      buttonLoading: false
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.id = this.$route.params.id
    this.ecourse = getUrlKey('ecourse')
    this.init()
  },
  methods: {
    ShowFloat,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/DiveLearn/getElearnInfoById',
        method: 'post',
        data: {
          studentId: this.id,
          eCourseId: this.ecourse
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.activeTab = 0
        // console.log(this.data.courseList[0].name + ' ' + this.data.courseList[0].studentId)
        // console.log(this.data.courseList[1].name + ' ' + this.data.courseList[1].studentId)
        // var a = JSON.parse(JSON.stringify(this.data.courseList))
        // this.data.courseList = []
        // this.data.courseList = a
      })
    },
    onTabChange() {
      if (this.activeTab === '') {
        return
      }
      if (this.activeTab === 'more') {
        Dialog.confirm({
          title: '更多课程',
          message: '是否要查看更多课程?'
        })
          .then(() => {
            this.$router.push('/store/list?type=3712126921094463488')
          })
          .catch(() => {
            this.activeTab = ''
            return
          })
        return
      }

      this.id = this.data.courseList[this.activeTab].studentId
      this.ecourse = this.data.courseList[this.activeTab].eCourseId
      this.data = undefined
      this.$router.push('/divetrip/eLearn/' + this.id + '?ecourse=' + this.ecourse)
      this.init()
    },
    onVideoPage(unit) {
      console.log('onVideoPage', unit)
      if (!unit.isActivity) {
        MyNotify('info', '请先完成前序单元!')
        return
      }
      this.$router.push('/divetrip/eVideo/' + unit.eCourseUnitId + '?student=' + this.data.studentId)
    },
    onTest(unit) {
      console.log('onTest', unit)
      if (!unit.isActivity) {
        MyNotify('info', '请先完成前序单元!')
        return
      }
      this.$router.push('/divetrip/exam?examId=' + unit.examId + '&studentId=' + this.data.studentId)
    },
    onExamError(unit) {
      console.log('onTest', unit)
      if (!unit.isActivity) {
        MyNotify('info', '请先完成前序单元!')
        return
      }
      this.$router.push('/divetrip/examErrorList/' + unit.examResultLastId)
    },
    onSubscribe(unit) {
      this.buttonLoading = true
      request({
        url: '/DiveLearn/OrderVideoconferencing',
        method: 'post',
        data: {
          studentId: this.id,
          eCourseUnitId: unit.eCourseUnitId
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '预约成功,开课前我们将会通知您，请留意!')
        this.init()
      })
    },
    onSubscribeCancel(unit) {
      this.buttonLoading = true
      request({
        url: '/DiveLearn/CancelVideoconferencing',
        method: 'post',
        data: {
          studentId: this.id,
          eCourseUnitId: unit.eCourseUnitId
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '取消成功,如需帮助请联系教练或者客服!')
        this.init()
      })
    }
  }
}
</script>
<style scoped>
.topTabRect{
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;
}
.topTabRect .tabList{
  padding: 1em;
}
.UnitRect{
  background-color: #fff;
  padding: 0 1em;
  margin-bottom: 0.5em;
}
.UnitRect .UnitTitle{
  padding:1em 0 0.5em 0;
  font-weight: 700;
}
.UnitRect .title{
  font-size: 0.9em;
  padding: 0.2em 0;
}
.UnitRect .title span{
  font-weight: 700;
  margin-left: 0.5em;
}
.UnitRect .about{
  font-size: 0.7em;
  color: #999;
}
.UnitRect .lineRect .score{
  font-size: 0.9em;
  font-weight: 700;
}
.UnitRect .lineRect{
  border-bottom: 1px solid #f5f5f5;
  padding: 0.5em 0;
}
.UnitRect .lineRect:last-child{
  border-bottom: none;
}
.UnitRectDisable{
  color: #999 !important;
}
.tag{
  float:right;
  margin-top: 0.7em;
  width: 3.5em;
  text-align: center;
  border-radius: 1em;
  color: #fff;
  border:1px solid #f5f5f5;
}
.tag span{
  font-size: 0.7em;
}

.examButtonRect{
  padding: 0.5em 0;
}

.rectDisable{
    color: #999 !important;
}
</style>
<style>
.topTabRect .van-tabs__nav--card {
  margin: 0;
}
</style>
